import React from 'react';
import { Chocolate2, Chocolate3, Person2, Person3 } from '~/assets';
import { Example5, Example6 } from '~/assets/png/examples';
import {
  ButtonIcon,
  ContentWrapper,
  Footer,
  Header,
  PageWrapper,
  SectionFeedbackPresentation,
  SectionTextMedia,
} from '~/components';
import { MORE_INFO_LINKS } from '~/utils/consts/section';
import {
  ButtonIconWrapper,
  GSbtWrapper,
  GreenSubtitle,
  OptionsList,
  OptionsWrapper,
  SbtWrapper,
  Subtitle,
  SubtitleWrapper,
} from './styles';

type DemoProps = {
  isShowing: boolean;
};

const Demo: React.FC<DemoProps> = ({ isShowing }) => (
  <PageWrapper>
    <Header />
    <ContentWrapper>
      <SectionTextMedia
        title="Referência em inovação"
        text="Sempre trazendo novidades no mercado e alinhando expectativas com os stakeholders do seu evento"
        imageLeft
        imageSrc={Chocolate2}
        buttonText="Comece a inovar"
      />
      <SectionTextMedia
        title="Diferentes combinações"
        text="Mostrando grande flexibilidade na elaboração dos doces para atender todas as demandas"
        imageSrc={Chocolate3}
        buttonText="Customizar doce"
      />
      <SubtitleWrapper id="subtitle">
        <SbtWrapper isShowing={isShowing}>
          <Subtitle>Clientes que já contrataram</Subtitle>
        </SbtWrapper>
        <GSbtWrapper isShowing={isShowing}>
          <GreenSubtitle>e aprovaram!</GreenSubtitle>
        </GSbtWrapper>
      </SubtitleWrapper>
      <SectionFeedbackPresentation />
      <SectionFeedbackPresentation
        bubbleText="Sen-sa-cio-nal 🤩!! É impressionante a alta flexibilidade de customização dos doces que eles proporcionam, além de serem muito saborosos é claro!"
        exampleImage={Example5}
        reviwerImage={Person2}
      />
      <SectionFeedbackPresentation
        bubbleText="Maravilhoso 👠👗🤩! Nós da organização do desfile de moda rimos muito no evento... enquanto as meninas desfilavam o pessoal se juntava nas mesas para admirar os doces haha!"
        exampleImage={Example6}
        reviwerImage={Person3}
      />
      <SectionTextMedia
        title="Saiba mais"
        text="Fique por dentro dos últimos lançamentos e modelos disponíveis para encomenda"
        buttonText="Pedir demonstração"
        customMedia={
          <OptionsWrapper>
            <OptionsList>
              {MORE_INFO_LINKS.map(({ icon, label }) => (
                <ButtonIconWrapper key={icon + label}>
                  <ButtonIcon btnText={label} icon={icon} />
                </ButtonIconWrapper>
              ))}
            </OptionsList>
          </OptionsWrapper>
        }
      />
    </ContentWrapper>
    <Footer />
  </PageWrapper>
);

export default Demo;
